import {
  BinaryChunkResponse,
  EndResponse,
  ErrorResponse,
  PongResponse,
  TextResponse,
} from "./types";

export function decodeBase64(encoded: string) {
  const binaryString = atob(encoded);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new TextDecoder().decode(bytes);
}

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
};

export function isTextResponse(data: unknown): data is TextResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as TextResponse).type === "text"
  );
}

export function isBinaryChunkResponse(
  data: unknown
): data is BinaryChunkResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as BinaryChunkResponse).type === "binary-chunk"
  );
}

function isErrorResponse(data: unknown): data is ErrorResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as ErrorResponse).type === "error" &&
    typeof (data as ErrorResponse).message === "string"
  );
}

function isPongResponse(data: unknown): data is PongResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as PongResponse).type === "pong" &&
    (data as PongResponse).pong === "pong"
  );
}

function isEndResponse(data: unknown): data is EndResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as EndResponse).type === "end"
  );
}

export const getText = (data: unknown) =>
  isTextResponse(data) ? data.result : undefined;
export const getBinaryChunk = (data: unknown) =>
  isBinaryChunkResponse(data) ? data.value : undefined;
export const getErrorMessage = (data: unknown) =>
  isErrorResponse(data) ? data.message : undefined;
export const isError = (data: unknown) => isErrorResponse(data);
export const isPong = (data: unknown) => isPongResponse(data);
export const isEnd = (data: unknown) => isEndResponse(data);

export function nodeStreamToWebReadable(nodeStream: any) {
  return new ReadableStream({
    start(controller) {
      nodeStream.on("data", (chunk: any) => {
        controller.enqueue(chunk);
      });
      nodeStream.on("end", () => {
        controller.close();
      });
      nodeStream.on("error", (err: any) => {
        controller.error(err);
      });
    },
  });
}

export function getIsMediaSourceSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.MediaSource !== "undefined" &&
    typeof MediaSource.isTypeSupported === "function"
  );
}
